import { lazy } from 'react';

export const LazyPrepAndSendPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--prep-and-send-page" */ './prep-and-send-page'
    ),
);
